import React from 'react';
import { IntlProvider } from 'react-intl';
import { DEFAULT_LOCALE } from '../constants/locales';
import messages from '../config/i18n/messages';

import flattenObject from '../utils/flattenObject';
/**
 * Wrap component with IntlProvider
 */
const withIntl = (WrappedComponent: any) => (props: any) => (
  <IntlProvider
    locale={ DEFAULT_LOCALE}
    messages={flattenObject(messages)}
    >
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <WrappedComponent {...props} />
  </IntlProvider>
);

export default withIntl;